import BaseStorage from './index';

export default class VariantStorage extends BaseStorage {
  constructor() {
    super();
    this.state = {
      currentVariant: null,
      // FIXME: Rename this key to 'purchaseType' or something similar and refactor all the code that uses it
      subscription: 'subscription'
    };
  }

  setCurrentVariant = (currentVariant) => {
    this.setState({ ...this.state, currentVariant });
  };

  setSubscription = (subscription) => {
    this.setState({ ...this.state, subscription });
  };
}
